/**
 * @title quick-membership-checkout.js: Feature level module
 * @description The interface for quick membership checkout. These methods
 *              are bound in /QuickMembershipCheckoutView
 *              (QuickMembershipPurchaseCheckoutBody.jsp).
*/

define(['renewMembership','quickRenewAddressHelper','membershipValidation'], function(RenewMembership,QuickRenewAddressHelper,MembershipValidation) {
  let QuickMembershipCheckout = {
    /**
     * Initialize the quick membership checkout specific functions
     * @return {void}
     */
    init: function(page) {
    
      COSTCO.MembershipHelper.isQuickMembership = true;
      
      QuickRenewAddressHelper.init();
    	
      switch(page) {
      	case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE:
      		COSTCO.Application.applicationPreprocesses();
      		QuickMembershipCheckout.bindHeaderAndFooterLinksForLeavePageModal(QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE);
      		break;
      	case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW:
      		RenewMembership.init();
      		QuickMembershipCheckout.bindHeaderAndFooterLinksForLeavePageModal(QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW);
      		break;
      }
      
      this.initDefaultPaymentCheckbox();
      this.setValidationDefaults();
    },
    constants: {
      QUICK_MEMBERSHIP: 'quick-membership',
      QUICK_MEMBERSHIP_PURCHASE: 'quick-membership-purchase',
      QUICK_MEMBERSHIP_RENEW: 'quick-membership-renew'
    },
    /**
     * Sets validation defaults specific for this sub-module.
     * @return {void}
     */
    setValidationDefaults: function() {
      try {
        if ($.validator.defaults.ignore.indexOf(':hidden') == -1) {
          let ignoreSelectors = $.validator.defaults.ignore.length > 0 ? $.validator.defaults.ignore + ", :hidden" : ":hidden";
          $.validator.setDefaults({ignore: ignoreSelectors});
        }
      } catch (err) {
        console.error('Error while setting validation rules: ' + err.message);
      }
    },
    /**
     * Ticks the Default Payment checkbox for US store
     * @return {void}
    */
    initDefaultPaymentCheckbox: function() {
    	if (wcs.storeId == '10301') {
    		$('#CheckoutPaymentForm').find('#save_CC').prop('checked', true);
    	} 
    },
    /**
     * Handles Choose a Membership radio button interaction on Quick Renew Post-Lockdown page
     * @return {void}
     */
    chooseMembership: function(memberType, isUpgrade) {
		$('#renew-membership-block, #upgrade-membership-block').toggleClass('radio-selected-background');
		let tncDiv = $('#membership-terms-div');
		isUpgrade ? tncDiv.removeClass('hide') : tncDiv.addClass('hide');
		MembershipValidation.renewMembership(memberType, false, isUpgrade, 'postLockdown');
    },
    /**
     * Showing leave page modal if user chooses to cancel shopping
     * @param {string} flowType	type of quick membership checkout flow (QUICK_MEMBERSHIP_PURCHASE | QUICK_MEMBERSHIP_RENEW)
     * @param {string} secondaryButtonHref	To set where secondary button should redirect
     */
    initiateLeavePageModal: function(flowType, secondaryButtonHref) {
      let isCanadaFrench = wcs.langId === '-25' && wcs.storeId === '10302';
	  let dialogClasses = 'leave-page-modal ' + (isCanadaFrench ? 'button-modal-fix' : '');
	  let modalTextObj = {};
      switch (flowType) {
      	case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE:
      		modalTextObj.primaryButton = messages.STAY_ON_PAGE_BUTTON;
      		modalTextObj.secondaryButton = memberOnlyFeatureEnabled ? messages.MEMBERSHIP_VALIDATION_Browse_Button_Text : messages.LEAVE_PAGE_BUTTON;
      		modalTextObj.body = memberOnlyFeatureEnabled ? messages.MOP_QUICK_PURCHASE_Checkout_PostLockdown_Leave_Page_Body : messages.LEAVE_PAGE_POP_UP_BODY
      		break;
      	case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW: 
      		modalTextObj.primaryButton = messages.STAY_ON_PAGE_BUTTON;
      		modalTextObj.secondaryButton = memberOnlyFeatureEnabled ? messages.MEMBERSHIP_VALIDATION_Browse_Button_Text : messages.LEAVE_PAGE_BUTTON;
      		modalTextObj.body = memberOnlyFeatureEnabled ? messages.MOP_QUICK_PURCHASE_Checkout_PostLockdown_Leave_Page_Body_Renew : messages.LEAVE_PAGE_POP_UP_BODY
      		break;
      }
      
      COSTCO.dialog.createExtDialogBox({
        title: messages.LEAVE_PAGE_POP_UP_TITLE,
        body: modalTextObj.body,
        primary: modalTextObj.primaryButton,
        secondary: modalTextObj.secondaryButton,
        dialogclasses: dialogClasses,
        primary_event: function() {
          COSTCO.dialog.close();
        },
        secondary_event: function() {
        	let urlParam = {'actionType':'clearTargetedCart','backURL':secondaryButtonHref};
        	let clearCartUrl = $('#clear-cart-cmd').val()+'?'+jQuery.param(urlParam);
        	
        	window.location.href = clearCartUrl;
        },
      });
    },
    
    /**
     * Binding header and footer links for initiating leave page modal
     * @param {string} flowType	type of quick membership checkout flow (QUICK_MEMBERSHIP_PURCHASE | QUICK_MEMBERSHIP_RENEW)
     */
    bindHeaderAndFooterLinksForLeavePageModal: function(flowType) {
        
        let headerAndFooterLinks = $('#header-checkout-widget, #footer-bottom').find("a");
        headerAndFooterLinks.click(function () {
            var addressValue = $(this).attr("href");
            if(addressValue != '#')
            	QuickMembershipCheckout.initiateLeavePageModal(flowType, addressValue);
            return false;
        });
             
    },
    /**
     * Setting individual price amount for affiliate member
     */
    setAffiliateMembershipPriceIfAddingNewAffiliates: function() {
        
        let configProduct = COSTCO.util.getFromSession('configProduct');
        if(configProduct.type == 'ADDMEMBER_AFFILIATE_BUSINESS') {
        	$('#membership-price').hide();
        	let affiliateCount = $('.affiliate-price').length;
        	let totalPrice = $('#outstandingPrincipal').val();
        	let affiliatePrice = totalPrice / affiliateCount;
        	QuickMembershipCheckout.setAffiliatePrice(affiliatePrice);
        }
    },
    /**
     * For each affiliate set appropriate price
     * @param {string} price
     */
    setAffiliatePrice: function(price) {
        return $('.affiliate-price').map(function() {
    		this.innerHTML = '$' + parseFloat(Math.round(price * 100) / 100).toFixed(2);
		});
             
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.QuickMembershipCheckout = QuickMembershipCheckout;
  return QuickMembershipCheckout;
});



// WEBPACK FOOTER //
// ./js/membership/quick-membership-checkout.js